import axios from 'axios';
export default axios.create({

    //baseURL:'http://192.168.0.109/carqadmin/public/api/user/'
    baseURL:'https://secureit.qleenit.com/public/api/CB15B23C-94DA-4DFC-84DB-44B1E3333114user/'
});